import { SessionService } from './session.service';

export class RowDensityManager {
    readonly min = 20;
    readonly max = 50;
    readonly step = 5;
    current = 40;
    private readonly sessionKey = 'RowDensity';

    constructor(private sessionService: SessionService) { }

    public initialize(): void {
		const data = this.sessionService.get<number>(this.sessionKey);
		if (data) this.current = data;
    }

    public onChange() {
        this.sessionService.put(this.sessionKey, this.current.toString());
    }
}
